// material ui components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// libraries
import classNames from "classnames";

// constants
import { FOURTH_STEP_DESCRIPTION, FOURTH_STEP_HEADER } from "../constants";

// styles
import styles from "../styles.module.css";
import { OnboardingType } from "../onboarding";

interface Props {
  type: OnboardingType;
}

const Fourth: React.FC<Props> = ({ type = OnboardingType.LARGE }: Props) => {
  return (
    <Box className={styles.container}>
      <Box
        className={classNames(
          styles.image_wrapper,
          type === OnboardingType.SMALL && styles.image_wrapper_smaller
        )}>
        <Box component="img" src="/assets/images/onboarding-four.png" />
      </Box>
      <Box className={styles.text_wrapper}>
        <Typography
          className={classNames(
            styles.onboardingText,
            type === OnboardingType.SMALL && styles.onboardingSmaller
          )}
          variant="h1">
          {FOURTH_STEP_HEADER}{" "}
        </Typography>
        {type === OnboardingType.LARGE && (
          <Typography className={styles.onboardingText} variant="body1">
            {FOURTH_STEP_DESCRIPTION}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default Fourth;
